import {createStyles} from '@material-ui/styles';
import type {Theme} from '@material-ui/core';
import * as colors from 'assets/theme/colors';

export default createStyles((theme: Theme) => ({
    header: {
        textAlign: 'center',
        fontFamily: 'Arial, Verdana, Droid Sans, Benton Sans',
        color: theme.palette.secondary.main,
        fontSize: theme.typography.pxToRem(18),
        fontWeight: theme.typography.fontWeightBold,
    },
    content: {
        maxHeight: 450,
        textAlign: 'center',
        lineHeight: '1.25rem',
        lineHeightStep: '18px',
        color: theme.palette.secondary.main,
        fontSize: theme.typography.pxToRem(16),
        fontWeight: theme.typography.fontWeightBold,
    },
    container: {
        paddingLeft: 0,
        paddingRight: 0,
    },
    textBreaker: {
        hyphens: 'auto',
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
    },
    paper: {
        width: '100%',
        minHeight: '90%',
        margin: '0 auto',
        padding: theme.spacing(2),
        border: `1px solid ${colors.primary.A00}`,
        backgroundColor: `${colors.neutrals.A10} !important`,
    },
    errors: {
        color: colors.accent.A01,
    },
    default: {
        color: colors.darkGray,
    },
}));
